import { Link } from 'react-router-dom';
import type { RequestSimulationRunResponse } from '@library/types/simulations';
import { StatusIndicator } from '@library/components/StatusIndicator';
import { translateSimStatus } from '@bo-utils/simulations';

export interface SimulationRowProps {
  gameId: string;
  leagueId: string;
  simulation: RequestSimulationRunResponse;
}

export const SimulationRow = ({
  gameId,
  leagueId,
  simulation
}: SimulationRowProps) => {
  const simStatus = simulation.attributes.simulation_run_status;

  return (
    <Link
      className="border-soFresh-140 text-soClean-110 hover:bg-soFresh-120 group/user relative flex items-center border-b text-xs xl:text-sm"
      to={`/simulations/${leagueId}/${gameId}/${simulation.id}`}
    >
      <span className="w-1/6 p-3">{simulation.id}</span>

      <div className="flex w-1/2 items-center p-3">
        <span className="text-sm">
          {simulation.attributes.simulation_run_name}
        </span>
      </div>

      <div className="flex w-1/6 items-center gap-2 p-3">
        <StatusIndicator status={simStatus} />
        <p>{translateSimStatus(simStatus)}</p>
      </div>

      <span className="w-1/6 p-3">
        {simulation.attributes.simulation_run_type}
      </span>
    </Link>
  );
};
